import ForbiddenException from '../../lib/ForbiddenException';
import User from '../containers/User';

async function retrieveMe() {
  const path = '/api/users/me';
  const resp = await fetch(path);

  if (resp.status == 200) {
    const json = await resp.json();
    const data = new User();
    data.load(json);
    return data;
  } else if (resp.status == 403) {
    throw new ForbiddenException();
  }

}

export default retrieveMe;
